















































































































import {
  computed, defineComponent, reactive, ref, watch,
} from '@vue/composition-api';
import { useFormat } from 'vivat';
import { useQuery, useResult } from '@vue/apollo-composable';

import useHighChartMap from '@/useHighChartMap';

import getDeliveryTime from '@/gql/report/analytic/getDeliveryTime.gql';

import Heatmap from '@/components/Map/Heatmap.vue';
import CommonIconTop from '@/components/CommonIconTop.vue';

const NOW = new Date();

const TransferDuration = defineComponent({
  components: {
    Heatmap,
    CommonIconTop,
  },
  setup() {
    const { getProperty } = useHighChartMap();
    const toDate = (date: string) => useFormat.date(date).displayFullThaiDate();
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    const getYear = (date: string) => useFormat.date(date).dayjs.get('year');
    const backwardTenYear = Array.from({ length: 10 }, (x, i) => new Date().getFullYear() + 543 - i);
    const filter = reactive({
      range: {
        from: useFormat.date(NOW).computerShortDate(),
        to: useFormat.date(NOW).computerShortDate(),
      },
    });
    const computedFilter = computed(() => {
      if (filter.range.from === filter.range.to) return {};
      return {
        range: {
          from: useFormat.date(filter.range.from).computerShortDate(),
          to: useFormat.date(filter.range.to).computerShortDate(),
        },
      };
    });
    const donutType = [
      { display: 'By Top Hub/Branch (Days)', name: 'topHub' },
      { display: 'By Top Area (Days)', name: 'topArea' },
      { display: 'By Top Province (Days)', name: 'topProvince' },
      { display: 'By Bottom Hub/Branch (Days)', name: 'bottomHub' },
      { display: 'By Bottom Area (Days)', name: 'bottomArea' },
      { display: 'By Bottom Province (Days)', name: 'bottomProvince' },
    ];

    const { result: getDeliveryTimeResult, loading: getDeliveryTimeLoading } = useQuery(getDeliveryTime, () => ({
      timeframe: computedFilter.value.range,
    }));
    const deliveryTimeSummary = useResult(getDeliveryTimeResult, { all: [] }, (data) => data.deliveryTimeSummary);
    const day1 = useResult(getDeliveryTimeResult, { countMatch: 0 }, (data) => data.day1);
    const day2 = useResult(getDeliveryTimeResult, { countMatch: 0 }, (data) => data.day2);
    const day3 = useResult(getDeliveryTimeResult, { countMatch: 0 }, (data) => data.day3);
    const day4 = useResult(getDeliveryTimeResult, { countMatch: 0 }, (data) => data.day4);
    const day7 = useResult(getDeliveryTimeResult, { countMatch: 0 }, (data) => data.day7);
    const provinces = computed(() => getDeliveryTimeResult?.value?.provinces || []);
    const topHubs = useResult(getDeliveryTimeResult, [], (data) => data.topHubs);
    const bottomHubs = useResult(getDeliveryTimeResult, [], (data) => data.bottomHubs);
    const topAreas = useResult(getDeliveryTimeResult, [], (data) => data.topAreas);
    const bottomAreas = useResult(getDeliveryTimeResult, [], (data) => data.bottomAreas);
    const topProvinces = useResult(getDeliveryTimeResult, [], (data) => data.topProvinces);
    const bottomProvinces = useResult(getDeliveryTimeResult, [], (data) => data.bottomProvinces);

    const thMonthsMini = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
    const selectedYear = ref(new Date().getFullYear() + 543);
    const computedSeriesData = computed(() => deliveryTimeSummary.value.all?.map((val: any) => ({
      x: thMonthsMini[val.month - 1],
      y: val.duration,
    })));

    const areaCharts = computed(() => ({
      options: {
        dataLabels: { enabled: false },
        yaxis: {
          opposite: false,
          labels: {
            formatter: (val: any) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
          },
        },
      },
      series: [
        {
          name: 'ระยะเวลาจัดส่ง (วัน)',
          data: computedSeriesData.value,
        },
      ],
    }));

    const colorIndex = ref(0);
    const COLORS = ['pink', 'green', 'blue', 'yellow', 'red', 'gray', 'orange', 'teal', 'indigo', 'purple'];
    function getColor() {
      if (colorIndex.value === 9) colorIndex.value = 0;
      else colorIndex.value += 1;
      return COLORS[colorIndex.value];
    }

    const donutChart = computed(() => {
      let topHub: any = [];
      if (topHubs.value.length === 0) topHub = [];
      else {
        topHub = topHubs.value?.map((areaElm: any) => ({
          name: areaElm.name,
          data: areaElm.duration,
          color: getColor(),
        }));
      }

      let topArea: any = [];
      if (topAreas.value.length === 0) topHub = [];
      else {
        topArea = topAreas.value?.map((areaElm: any) => ({
          name: areaElm.name,
          data: areaElm.duration,
          color: getColor(),
        }));
      }

      let topProvince: any = [];
      if (topProvinces.value.length === 0) topHub = [];
      else {
        topProvince = topProvinces.value?.map((areaElm: any) => ({
          name: areaElm.name,
          data: areaElm.duration,
          color: getColor(),
        }));
      }

      let bottomHub: any = [];
      if (topHubs.value.length === 0) topHub = [];
      else {
        bottomHub = bottomHubs.value?.map((areaElm: any) => ({
          name: areaElm.name,
          data: areaElm.duration,
          color: getColor(),
        }));
      }

      let bottomArea: any = [];
      if (bottomAreas.value.length === 0) topHub = [];
      else {
        bottomArea = bottomAreas.value?.map((areaElm: any) => ({
          name: areaElm.name,
          data: areaElm.duration,
          color: getColor(),
        }));
      }

      let bottomProvince: any = [];
      if (bottomProvinces.value.length === 0) topHub = [];
      else {
        bottomProvince = bottomProvinces.value?.map((areaElm: any) => ({
          name: areaElm.name,
          data: areaElm.duration,
          color: getColor(),
        }));
      }

      return {
        topHub,
        bottomHub,
        topArea,
        bottomArea,
        topProvince,
        bottomProvince,
      };
    });

    const render = ref(true);
    const computedData = computed(() => {
      render.value = false;
      const _value: any = {
        northern: [],
        northeastern: [],
        central: [],
        eastern: [],
        western: [],
        southern: [],
      };

      function pushToArray(_region: string, province: string | number, value: number | string) {
        if (_region === 'NORTHERN') _value.northern.push([`th-${province}`, value]);
        else if (_region === 'NORTHEASTERN') _value.northeastern.push([`th-${province}`, value]);
        else if (_region === 'CENTRAL') _value.central.push([`th-${province}`, value]);
        else if (_region === 'EASTERN') _value.eastern.push([`th-${province}`, value]);
        else if (_region === 'WESTERN') _value.western.push([`th-${province}`, value]);
        else if (_region === 'SOUTHERN') _value.southern.push([`th-${province}`, value]);
      }

      const hasValue: number[] = [];
      // eslint-disable-next-line
      provinces.value?.forEach((elm: any) => {
        hasValue.push(elm.name);
        const { shortForm, region } = getProperty(elm.name);
        pushToArray(region, shortForm, elm.duration);
      });
      for (let i = 0; i < 78; i += 1) {
        if (hasValue.indexOf(i) === -1) {
          const { shortForm, region } = getProperty(i);
          pushToArray(region, shortForm, 0);
        }
      }
      render.value = true;

      return _value;
    });

    return {
      toCurrency,
      toDate,
      getYear,
      filter,

      donutType,
      areaCharts,
      donutChart,
      backwardTenYear,
      selectedYear,

      computedData,
      render,

      deliveryTimeSummary,

      day1,
      day2,
      day3,
      day4,
      day7,
    };
  },
});

export default TransferDuration;
